import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Crown, Loader2 } from 'lucide-react';

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [params] = useSearchParams();
    const joinFlag = params.get('join') === '1';
    const [form, setForm] = useState({ username: '', email: '', password: '', join_club: joinFlag });
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await register(form.username, form.email, form.password, form.join_club);
            toast.success(form.join_club ? 'Welcome to the club!' : 'Account created');
            nav('/');
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'Could not register');
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="rrm-panel p-6">
                <h1 className="font-display text-3xl text-white">CREATE ACCOUNT</h1>
                <p className="text-white/60 text-sm mt-1">Save vehicles, track orders, unlock club perks.</p>
                <form onSubmit={submit} className="mt-6 space-y-3">
                    <input required value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} placeholder="Username" data-testid="register-username-input" className="w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm" />
                    <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="register-email-input" className="w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm" />
                    <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password (min 6 chars)" minLength={6} data-testid="register-password-input" className="w-full bg-white/5 border border-white/10 rounded-md px-3 py-2 text-sm" />
                    <label className="flex items-center gap-2 text-sm text-white/70">
                        <input type="checkbox" checked={form.join_club} onChange={(e) => setForm({ ...form, join_club: e.target.checked })} data-testid="register-join-club" className="accent-amber-500" />
                        <Crown className="w-4 h-4 text-amber-400" /> Join the RRM club (free)
                    </label>
                    <button disabled={busy} data-testid="register-submit-button" className="w-full px-4 py-2.5 rounded-md bg-[var(--rrm-red)] hover:bg-[var(--rrm-red2)] text-white font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50">
                        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Create account
                    </button>
                </form>
                <div className="mt-4 text-sm text-white/60">
                    Already a member? <Link to="/login" className="text-amber-300">Sign in</Link>
                </div>
            </div>
        </div>
    );
}
